import { Component, OnInit, OnDestroy } from '@angular/core';
import { SpinnerService } from './spinner.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css']
})
export class SpinnerComponent implements OnInit,OnDestroy {
  subscription!: Subscription;
  showSpinner: boolean = false;
  constructor(private spinnerService :SpinnerService) { }

  ngOnInit() {
    this.subscription = this.spinnerService.showSpinner$.subscribe(
      ( showSpinner: boolean) => this.showSpinner = showSpinner
      );
  }

  ngOnDestroy() {
    this.subscription && this.subscription.unsubscribe();
  }
}
